<template>
<body>
  <div class="order_header">
    <div class="order_nav2 li4">
      <ul>
        <li
          :class="searchInfo.situation == '0' ? 'bes_nav_picked' : '' "
          @click="changeSituation('0')"
        >
          <a href="javascript:void(0);">未转正</a>
        </li>
        <li
          :class="searchInfo.situation == '1' ? 'bes_nav_picked' : '' "
          @click="changeSituation('1')"
        >
          <a href="javascript:void(0);">未收款</a>
        </li>
        <li
          :class="searchInfo.situation == '2' ? 'bes_nav_picked' : '' "
          @click="changeSituation('2')"
        >
          <a href="javascript:void(0);">已收款</a>
        </li>
        <li
          :class="searchInfo.situation == '-1' ? 'bes_nav_picked' : '' "
          @click="changeSituation('-1')"
        >
          <a href="javascript:void(0);">已取消</a>
        </li>
      </ul>
    </div>
    <div class="order_line">
      <span :style="getStyle"></span>
    </div>
    <div class="search_panel">
      <table id="search_panel_table">
        <tr>
          <td class="search_tip" style="padding-left: 3%;">报名日期</td>
          <td>
            <div class="add_time">
              <!-- <fy-mobile-date v-model="searchInfo.add_time"></fy-mobile-date> -->
              <fy-el-date v-model="searchInfo.add_time"></fy-el-date>
            </div>
          </td>
          <td class="search_tip" style="padding-left: 3%;">出行日期</td>
          <td>
            <div class="add_time">
              <!-- <fy-mobile-date v-model="searchInfo.depart_time"></fy-mobile-date> -->
              <fy-el-date v-model="searchInfo.depart_time"></fy-el-date>
            </div>
          </td>
        </tr>
        <tr>
          <td class="search_tip" style="padding-left: 2%; padding-right: 0.8em;">订单联系人</td>
          <td>
            <input
              class="agent_contact_person"
              id="contact_person"
              name="contact_person"
              placeholder="请输入联系人进行搜索"
              type="text"
              v-model="searchInfo.contact_person"
            >
          </td>
          <td class="search_td">
            <input
              @click="search"
              class="agent_search"
              id="search"
              name="search"
              type="submit"
              value="搜索"
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
  <!-- order_header结束 -->
  <paging
    :current_change="handleCurrentChange"
    :loading="paging_load.loading"
    :not_data="!searchInfo.total || searchInfo.total <= 0"
    :total="searchInfo.total"
    v-if="!isInit"
    v-model="searchInfo.current"
  >
    <div class="bes_list" v-if="!isInit">
      <!-- 订单列表 -->
      <div class="bes_num" style="position: relative;" v-for="(orderInfo, index) in orderList">
        <p class="is-checkbox" v-if="searchInfo.situation == '2'">
          <el-checkbox v-if="orderInfo.uninvoice_amount > 0 && reset " v-model="checked[index]"></el-checkbox>
        </p>
        <div class="call_agent">
          <input name="username" type="hidden" value>
          <input name="domainName" type="hidden" value>
          <span>联系人：</span>
          <em class="order_face_em">{{orderInfo.order_info.contact_person}}</em>
          <a :href="'tel:' + orderInfo.order_info.contact_tel">
            <img alt="电话" src="~@/assets/images/html/call_03.png">
            <i>{{orderInfo.order_info.contact_tel}}</i>
          </a>
        </div>
        <div class="bes_num_bottom">
          <div class="bes_bottom_txt">
            <p class="orderlist_p overflow-ellipsis-line1 orderlist_p-name" style="width: 70%;">
              产品名称：
              <i
                :title="orderInfo.order_info.product_name"
              >{{orderInfo.order_info.product_name | omitShow(30)}}</i>
            </p>
            <a
              @click="$pushByName('agentOrderDetail',{order_id:orderInfo.order_info.order_info_id})"
              href="javascript:void(0);"
            >
              <img alt src="~@/assets/images/html/right_blue_arrow_03.png">
              <em>查看订单详情</em>
            </a>
          </div>
          <div class="bes_bottom_txt" style="width:45%;float: left;">
            <p class="orderlist_p">订单编号：</p>
            <i>{{orderInfo.order_info.order_info_id}}</i>
          </div>
          <div class="bes_bottom_txt" style="width:55%;float: right;">
            <div>
              <p class="orderlist_p">报名时间：</p>
              <i>{{$dateUtil.df(orderInfo.order_info.add_time, 'YYYY-MM-DD HH:mm:ss')}}</i>
            </div>
          </div>
          <div class="bes_bottom_txt" style="width:45%;float: left;">
            <p class="orderlist_p">订单应收：</p>
            <i style=" color:#0075e2;">{{orderInfo.order_info.total_amount | money | currency}}</i>
          </div>
          <div
            class="bes_bottom_txt"
            style="width:55%;float: left;"
            v-show="searchInfo.situation == '1' "
          >
            <p class="orderlist_p">未收金额：</p>
            <i
              style=" color:#0075e2;"
            >{{$number.subtract($number.subtract(orderInfo.order_info.total_amount, orderInfo.order_info.total_received_amount), unusedAmounts[orderInfo.order_info.order_info_id]) | money | currency}}</i>
          </div>
        </div>
        <div class="clearfix"></div>
        <div>
          <div class="diylist_num_line_button" v-if="searchInfo.situation == '2' && 
                 ( appInfoList[orderInfo.order_info.order_info_id].app_status != '发票申请' && orderInfo.order_info.total_amount >0 )">
                 <a href="javascript:void(0);" 
                   @click="getToInvoice(orderInfo)"
                   >
                    <em>{{ appInfoList[orderInfo.order_info.order_info_id].app_status }}</em>
                 </a>
              </div>
          <div
            class="diylist_num_line_button"
            v-if="searchInfo.situation == 0 || searchInfo.situation == 1 || searchInfo.situation == 2"
          >
            <a
              @click="$pushByName('routeOrderEdit',{order_id:orderInfo.order_info.order_info_id,income:'list'})"
              href="javascript:void(0);"
            >编辑</a>
          </div>
          <div class="diylist_num_line_button" v-if="searchInfo.situation == 0">
            <a @click="confirm(orderInfo.order_info.order_info_id)" href="javascript:void(0);">转正</a>
          </div>
          <div
            class="diylist_num_line_button"
            v-if="$defines.is_allow_pay && (searchInfo.situation == 0 || searchInfo.situation == 1)"
          >
            <a
              @click="$pushByName('orderReceive',{order_id:orderInfo.order_info.order_info_id})"
              href="javascript:void(0);"
            >收款</a>
          </div>
          <div class="diylist_num_line_button" v-if="searchInfo.situation == 0">
            <a @click="cancel(orderInfo.order_info.order_info_id)" href="javascript:void(0);">取消</a>
          </div>
        </div>
      </div>
      <!-- 订单列表结束 -->
        <el-dialog
            :visible.sync="dateInvoiceDialogVisible"
            :modal-append-to-body = "false">
            <invoice
                :invoiceInfo="invoiceInfo"
                :isInvoiced="isInvoiced"
                :orderInfo="orderInfo"
                :appInvoice="appInvoice"
                v-if="dateInvoiceDialogVisible"
                @closeDialog="closeDialog">
            </invoice>
        </el-dialog>
    </div>
    <div class="clearfix"></div>
      <div> <input class="invoice-request" type="button" v-if="searchInfo.situation == '2'" @click="invoiceApp()" value="发票申请" ></div>
  </paging>
</body>
</template>
<style scoped>
@import '../../assets/css/pages/agent/css.css';

.add_time {
  width: 130%;
  margin-left: -50%;
  margin-top: 5%;
  float: left;
  font-size: 15px;
}

.order_line span {
  position: absolute;
  top: 0;
  left: 0;
  width: 25%;
  height: 0.2em;
  background-color: #81b5f1;
}
.invoice-request {
  background-color: #5595e3;
  /* border-radius: 5px; */
  width: 110px;
  /* padding: 3% 2%; */
  color: #fff;
  margin-top: 0.5em;
  float: right;
  font-size: 14px;
  text-align: center;
}

.order_nav2 {
  padding-bottom: 0;
  padding-top: 5%;
  height: 3em;
}

.order_nav2 ul li {
  width: 25%;
  float: left;
  text-align: center;
}

.agent_contact_person {
  margin-left: -50%;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  width: 123%;
  padding: 3%;
  margin-top: 0.5em;
  font-size: 15px;
}

.agent_search {
  background-color: #5595e3;
  border-radius: 5px;
  width: 110px;
  font-size: 14px;
  padding: 3% 2%;
  color: #fff;
  margin-top: 0.5em;
  margin-left: 95px;
}

.date_remove_img {
  width: 10%;
  margin-left: 5%;
  margin-top: 7%;
}

.date_point_img {
  width: 3em;
  margin-left: 5%;
  margin-top: 7%;
}

.order_nav2 ul li.bes_nav_picked a {
  color: #81b5f1;
}

.diylist_num_line_button {
  padding: 1px 42px;
  background-color: #5595e3;
  border-radius: 5px;
  text-align: center;
  float: right;
  margin-right: 25px;
}

.diylist_num_line_button a {
  display: inline-block;
  height: 35px;
  line-height: 35px;
  color: #fff;
  font-size: 14px;
}

.is-checkbox {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 82px;
  left: 10px;
}
.page-component {
  text-align: center;
  margin-top: 3%;
}
</style>
<script>
let now = new Date()
let year = now.getFullYear()
let month = now.getMonth() + 1
let day = now.getDate()
let dateTime = Date.parse(now) // 当前时间时间戳
import { Paging } from '@/pages/components';
import Invoice from '@/pages/common/invoice.vue'


export default {
  name: 'AgentOrderList',
  componentName: 'AgentOrderList',
  components: {
    Paging,
    Invoice
  },
  data () {
    return {
      pages: 0,
      dateInvoiceDialogVisible: false,  //模态框开关
      isInvoiced: false, //是否申请完发票
      reset:true, 
      checked: [], // 复选框是否默认勾选
      appInfoList:{},
      appInvoice:{},
      orderInfo:[],
      invoiceInfo:[],
      orderList: [],
      searchInfo: { // 查询条件
        user_name: this.$sessionStorageUtil.get('agent_username'),
        add_time: 0,
        depart_time: 0,
        contact_person: '',
        situation: '0',
        depart_type: '',
        return_time: dateTime,
        contact_tel: '',
        search_combination: '',
        order_By: '',
        name: '', // 会员姓名
        mobile_phone: '', // 会员电话
        size: 10, // 每页显示数量
        current: 1, // 当前所在页
        total: 0, // 总页码数
      },
      unusedAmounts: {}, //未使用支付预收款汇总金额 
      paging_load: {
        loading: true
      },
      isInit: true
    }
  },
  created () {
    this.paging_load.loading = true
    if (this.$sessionStorageUtil.get('a_serrch_info_add_time')) {

      this.searchInfo.add_time = this.$sessionStorageUtil.get('a_serrch_info_add_time')

    }
    if (this.$sessionStorageUtil.get('a_serrch_info_depart_time')) {

      this.searchInfo.depart_time = this.$sessionStorageUtil.get('a_serrch_info_depart_time')

    }
    if (this.$sessionStorageUtil.get('a_serrch_info_contact_person')) {

      this.searchInfo.contact_person = this.$sessionStorageUtil.get('a_serrch_info_contact_person')
    }
    if (this.$sessionStorageUtil.get('a_serrch_info_situation')) {

      this.searchInfo.situation = this.$sessionStorageUtil.get('a_serrch_info_situation')
    }

    this.getOrderList();
  },
  computed: {
    showPay () {
      return this.searchInfo.situation != '1' && this.searchInfo.situation != '-1'
    },
    getStyle () {
      if (this.searchInfo.situation == '1') {

        return 'left: 25%'

      } else if (this.searchInfo.situation == '2') {

        return 'left: 50%'

      } else if (this.searchInfo.situation == '-1') {

        return 'left: 75%'
      }
    },

  },
  methods: {
    removeAddTime () {
      this.searchInfo.add_time = 0
    },
    removeDepartTime () {
      this.searchInfo.depart_time = 0
    },
    search () {
      this.orderList = []
      this.getOrderList()
    },
    loadMore () {
      this.searchInfo.current = this.searchInfo.current + 1
      this.getOrderList()
    },
    invoiceApp(){
       this.orderInfo = []
       this.isInvoiced = false
       for (let i = 0; i < this.checked.length; i++) {
        let isChecked = this.checked[i]
        if (isChecked == true) {
          this.orderInfo.push(this.orderList[i])
        }
      }
      if(this.orderInfo.length != 0) {
        var from_www = []
        this.orderInfo.forEach(element => {
          from_www.push(element.order_info.from_www)
        })
        for (let i = 0; i < from_www.length; i++ ){
         let isContact = from_www[i]
         if(isContact == 1) {
            this.$msg('该订单你没有权限开发票，需客人自己申请开票', 'error')
            return
          }
        }
        this.dateInvoiceDialogVisible = true
      } else {
        this.$msg('请选择需要开票的项目!','error',3000)
      }
    },
     closeDialog() {
      this.dateInvoiceDialogVisible = false
    },
    getToInvoice(orderInfo) {
      this.orderInfo= []
      this.orderInfo.push(orderInfo)
      this.invoiceInfo = this.appInfoList[orderInfo.order_info.order_info_id]
      this.isInvoiced = true
      this.dateInvoiceDialogVisible = true
    },
    getOrderList () { // 从后台接口获取订单列表，
      this.paging_load.loading = true
      const url = 'order_info/order_list'
      const params = this.searchInfo
      var fields = this.$myGet(url, params)
      fields.then(res => {
        let list = res.response.data.page.records
        this.unusedAmounts = res.response.data.unusedAmount
        this.appInfoList = res.response.data.appInfoMap;
        this.searchInfo.total = res.response.data.page.total;
        this.orderList = list;
        this.paging_load.loading = false
        this.isInit = false
      })
        .catch(err => {
          this.paging_load.loading = false
          console.log('err:' + err)
        })

      // 记住查询条件
      this.$sessionStorageUtil.set('a_serrch_info_add_time', this.searchInfo.add_time, 60 * 30)
      this.$sessionStorageUtil.set('a_serrch_info_depart_time', this.searchInfo.depart_time, 60 * 30)
      this.$sessionStorageUtil.set('a_serrch_info_contact_person', this.searchInfo.contact_person, 60 * 30)
      this.$sessionStorageUtil.set('a_serrch_info_situation', this.searchInfo.situation, 60 * 30)
    },
    changeSituation (val) { // 点击待付款、已付款、已取消时，改变状态，重新获取订单列表
      this.orderList = []
      this.searchInfo.current = 1
      this.searchInfo.situation = val
      this.getOrderList()
    },
    confirm (orderId) {
      this.$messageBox.confirm('是否确定转正订单？').then(() => {
        const url = 'order_route/confirm_order/' + orderId
        var fields = this.$myGet(url, {})
        var loading = this.$loadingIndicator.eleOpen('处理中...')
        fields.then(res => {
          if (res.response.data.result > 0) {
            this.$msg('订单转正成功！', 'success', 3000)
            this.changeSituation(this.searchInfo.situation)
          } else {
            this.$msg('订单转正失败', 'error', 3000)
          }
          loading.close()
        })
          .catch(err => {
            loading.close()
            this.$msg('订单转正失败', 'error', 3000)
          })
      }).catch(() => {

      })
    },
    cancel (orderId) {
      this.$messageBox.confirm('是否确定取消订单？').then(() => {
        const url = 'order_route/cancel_order/' + orderId
        var fields = this.$myGet(url, {})
        var loading = this.$loadingIndicator.eleOpen('处理中...')
        fields.then(res => {
          if (res.response.data.result > 0) {
            loading.close()
            this.changeSituation(this.searchInfo.situation)
          } else {
            this.$msg('订单取消失败', 'error', 3000)
          }
          loading.close()
        })
          .catch(err => {
            loading.close()
            this.$msg('订单取消失败', 'error', 3000)
          })
      }).catch(() => {

      })
    },
    // 点击页码数获取分页数据
    handleCurrentChange () {
      this.paging_load.loading = true
      this.reset = false
      this.checked.splice(0, this.checked.length)
      this.$nextTick(function () {  //点击分页取消选择
        this.reset = true;
      })
      const url = 'order_info/order_list'
      const params = this.searchInfo
      var fields = this.$myGet(url, params)
      fields.then(res => {
        let list = res.response.data.page.records
        this.appInfoList = res.response.data.appInfoMap;
        this.unusedAmounts = res.response.data.unusedAmount
        this.orderList = list
        this.searchInfo.total = res.response.data.page.total
        // this.paging_load.loading = false
      })
        .catch(err => {
          // this.paging_load.loading = false
          console.log('err:' + err)
        })
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/pages/agent/orderList.vue